import { withChartLayout } from 'components/common';
import ActivityOccupationalTherapy from 'components/features/chart/admission-history/activity-occupational-therapy/ActivityOccupationalTherapy';

const ActivityOccupationalTherapyPage = withChartLayout('Activity - Occupational Therapy Screen')(ActivityOccupationalTherapy);
export default ActivityOccupationalTherapyPage;
